import React from "react";
import PasswordActionForm from "./PasswordActionForm";

const SetPassword = () => <PasswordActionForm mode="setup" />;

export default SetPassword;
